/* eslint-disable @typescript-eslint/no-explicit-any */
import { mpfRListsHttp } from '../api/mpf-r-lists-http'

interface ChecklistMetadataLookup {
  CheckListMetadata_Code: number
  'ChecklistsListMetadataList/Name': any
  Code: number
  CommonMetadata_Code: number
  'CommonMetadataList/MetadataValue': any
  ItemCreated: Date
  ItemCreatedBy: any //Person_Single
  ItemModified: Date
  ItemModifiedBy: any //Person_Single
}
interface ChecklistMetadataLookupArgs {
  isArchivedFilter: false | null | true
  isAscending?: boolean
  orderBy?: string
}
const COLUMN_NAMES = {
  CheckListMetadata_Code: 'CheckListMetadata_Code',
  'ChecklistsListMetadataList/Name': 'ChecklistsListMetadataList/Name',
  Code: 'Code',
  CommonMetadata_Code: 'CommonMetadata_Code',
  'CommonMetadataList/MetadataValue': 'CommonMetadataList/MetadataValue',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
}
const LIST_NAME = 'ChecklistMetadataLookup'

const getChecklistMetadataLookup = async (
  args: ChecklistMetadataLookupArgs
): Promise<ChecklistMetadataLookup[]> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const ascending = args?.isAscending ?? true
  const orderBy = args?.orderBy ?? COLUMN_NAMES.Code

  const items = await list
    .query()
    .select(
      COLUMN_NAMES.CheckListMetadata_Code,
      COLUMN_NAMES['ChecklistsListMetadataList/Name'],
      COLUMN_NAMES.Code,
      COLUMN_NAMES.CommonMetadata_Code,
      COLUMN_NAMES['CommonMetadataList/MetadataValue'],
      COLUMN_NAMES.ItemCreated,
      COLUMN_NAMES.ItemCreatedBy,
      COLUMN_NAMES.ItemModified,
      COLUMN_NAMES.ItemModifiedBy
    )
    .orderBy([{ ascending: ascending, orderBy: orderBy }])
    .get()
  return [...items] as ChecklistMetadataLookup[]
}
export {
  COLUMN_NAMES,
  type ChecklistMetadataLookup,
  type ChecklistMetadataLookupArgs,
  LIST_NAME,
  getChecklistMetadataLookup,
}
